<template>
  <el-form
    ref="form"
    class="custom-form"
    size="large"
    :rules="rules"
    :model="form"
    label-width="200px">
    <el-row>
      <el-col :span="12">
        <el-form-item
          label="姓名："
          prop="idName">
          <el-input
            v-model="form.idName"
            show-word-limit
            clearable
            maxlength="12"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="联系电话："
          prop="mobile">
          <el-input
            v-model="form.mobile"
            show-word-limit
            clearable
            maxlength="15"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="原证书编号："
          prop="originalCertNo">
          <el-input
            v-model="form.originalCertNo"
            show-word-limit
            clearable
            maxlength="20"></el-input>
        </el-form-item>
      </el-col>
      <el-col
        v-if="type === 2"
        :span="12">
        <el-form-item
          label="拟报名申请等级："
          prop="level">
          <el-select v-model="form.level">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="原证书图片："
          prop="originalCertFile">
          <upload-with-crop
            v-model="form.originalCertFile"
            :showTip="false"
            :isLt2M="2048"
            :limit="1"
            :autoCropWidth="200"
            :autoCropHeight="80"></upload-with-crop>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label-width="0">
      <div class="user-submit">
        <el-button
          class="custom-btn"
          type="primary"
          size="large"
          @click="addluxurycertrenewal">{{ type === 1 ? '我要报名' : '我要申请' }}</el-button>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import { instance } from '../../search-page/axios'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
const levelList = [{ label: '中级', value: 2 }, { label: '高级', value: 3 }]
export default {
  name: 'PageSearchForm',
  components: { UploadWithCrop },
  inject: {
    type: { default: 1 }
  },
  data() {
    return {
      levelList,
      form: { idName: '', mobile: '', originalCertNo: '', level: 2, originalCertFile: [] },
      rules: {
        idName: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请填写联系电话', trigger: 'blur' }
        ],
        originalCertNo: [
          { required: true, message: '请填写原证书编号', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择拟报名申请等级', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    addluxurycertrenewal() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const [certFile] = this.form.originalCertFile
          instance
            .post(`v1/luxurycertrenewal/addluxurycertrenewal`, {
              ...this.form,
              type: this.type,
              originalCertFile: certFile ? certFile.url : null,
              level: this.type === 1 ? null : this.form.level
            })
            .then(res => {
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success(this.type === 1 ? '报名成功' : '申请成功')
                this.form = { ...this.form, ...this.$options.data().form }
              } else {
                this.$message.error(message)
              }
            })
            .catch(error => {
              this.$message.error(error.message)
            })
        }
      })
    },
    openViewer(url) {
      this.srcList = [url]
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
<style lang="stylus" scoped src="./page-search-form.styl"></style>
